import { render } from "./view-kv-customer.vue?vue&type=template&id=f6b03180"
import script from "./view-kv-customer.vue?vue&type=script&lang=js"
export * from "./view-kv-customer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/view-kv-customer/view-kv-customer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6b03180"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6b03180', __exports__)) {
    api.reload('f6b03180', __exports__)
  }
  
  module.hot.accept("./view-kv-customer.vue?vue&type=template&id=f6b03180", () => {
    api.rerender('f6b03180', render)
  })

}


export default __exports__